import React, { Component } from "react";
import {  Row, Col, Button, ListGroup, Form, Alert , Modal, Nav } from "react-bootstrap";

import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";

import { PacmanLoader } from 'react-spinners';
import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select';

export default class WithholdingsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "withholdings",
            dataRecord: "withholdings",
            dataSetPrimaryKey: "property_withholding_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            trust_proof: false
        };

        
        this.handleReleaseRecord = this.handleReleaseRecord.bind(this);
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }                
        
        if(this.props.userPermissions){
            console.log("In witholding list and have user permissions props")
            if(this.props.userPermissions.trust_proof){
                this.setState({trust_proof:true})
            }
            else{
                this.setState({trust_proof:false})
            }
        }
        this.handleSave();


        this.setState({ isLoading: false });      
    }

    async componentDidUpdate(prevProps){
        if(prevProps.userPermissions !== this.props.userPermissions)
            {
            if(this.props.userPermissions){
                console.log("In witholding list and have user permissions props")
                if(this.props.userPermissions.trust_proof){
                    this.setState({trust_proof:true})
                }
                else{
                    this.setState({trust_proof:false})
                }
            }
        }
    }
    



    componentWillUnmount() {
        this.setState({ addresses: [] });
    }



    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

   
    handleReleaseAllRecord = async ( event ) => {
        
        console.log("Remove withholding bulk");
        const fulldata =  [...this.props.data]
        let data = fulldata.filter((a) => { if(a.selected && (a.link_id == null || a.primary_classification == "Residential" || a.primary_classification == "Car Park")){return true;}else{return false;}} )
        
        var r = window.confirm("Please confirm you have proofed the selected Properties and would like to remove the HOLD status of each? Note: Selected HOLD records with a Link ID may be excluded from this batch update.");
        
        if (r === true) {
            

            for(var i=data.length-1;i>=0;i--)
            {                
                data[i].released_date = new Date();
                data[i].released_by = this.props.user; 
                data[i].last_edited_by = this.props.user;
            }
            await this.props.bulkSaveRecords(data).then((result) => {
                for(var i=fulldata.length-1;i>=0;i--){
                    if (data.map(r=>r.property_withholding_id) .indexOf(fulldata[i].property_withholding_id )>=0){
                        fulldata.splice(i, 1);
                    }
                    
                }
                this.props.updateTableState(fulldata, this.state.dataSet);
                window.alert("Hold removed.");
            });
        }
    
                            
    };


    handleReleaseRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("Remove withholding");
        let data = [...this.props.data];
        
        var r = window.confirm("Please confirm you have proofed the selected Properties and would like to remove the HOLD status of this Property?");
        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].released_date = new Date();
            data[cellInfo.index].released_by = this.props.user;
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }


    handleSave = async (cellInfo, event) => {
        
        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        // if (data[0].hasOwnProperty("sort_order")) {
        //     data.sort(function (a, b) { return a.sort_order - b.sort_order });
        // }
        // if (data[cellInfo.index].hasOwnProperty("main_address")) {
        //     data.sort(function (a, b) { return b.main_address - a.main_address });
        // }
        this.props.updateTableState(data, this.state.dataSet);

    }

    

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
            withholding_reason_id: null,
            withholding_text: null,
            link: null,
            property_id: this.props.filter.propertyid,            
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    
    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        if (cellInfo.column.id == "withholding_reason") {
            if (cellValue) {
                return (<div><Select

                    
                    value={{ value: cellValue, label: this.props.withholdingReasons.find(o => o.value === cellValue).label }}
                    onChange={this.handleWithholdingReasonInputChange.bind(null, cellInfo)}
                    options={this.props.withholdingReasons}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleWithholdingReasonInputChange.bind(null, cellInfo)}
                    options={this.props.withholdingReasons}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    className="no-border"
                /></div>
                );
            }
        }                               

        if (cellInfo.column.id.indexOf(["withholding_text"]) >= 0) {
            return (
                <Form.Control
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="text"
                    as="textarea"
                    rows={(Math.abs((cellValue||"").length/80)+1).toString()}
                    className="no-border form-control"
                    value={cellValue!=null? cellValue:""}
    
                />
            );
            }
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        // onBlur={this.handleSave.bind(null, cellInfo)}
                        //The only checkbox is the selected checkbox which we dont need to save

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

    getPropertiesLink(cityscopeReference) {
        const selectedProperties = this.props.data.filter(a => a.selected).map(a => a.property_key);
        if (selectedProperties.length === 0) return `../properties/${cityscopeReference}`;
        return `../properties/${cityscopeReference}?browselist=${selectedProperties.join(',')}`;
    }


    renderTable(data) {
        const columns = [

            {
                id: 'selected',
                Header: '',
                maxWidth: 50,
                accessor: 'selected',
                Cell:  this.renderEditable 
            },
            {
                id: 'property_key',
                Header: 'Cityscope Ref',
                maxWidth: 80,
                accessor: 'property_key',                
                Cell: e => <div>
                    <a target="_blank" rel="noopener noreferrer" href={this.getPropertiesLink(e.value)}> {e.value} </a>
                </div>
                    
            },                    
            {
                id: 'withhold_reason',
                Header: 'Reason',
                accessor: 'withholding_reason',
                maxWidth: 150

            },
            {
                id: 'withholding_text',
                Header: 'Additional Comments',
                accessor: 'withholding_text',
                maxWidth: 350,
                Cell: this.renderEditable,
                style: { 'white-space': 'unset' } 

            },
            {
                id: 'primary_classification',
                Header: 'Primary Classification',
                accessor: 'primary_classification',
                maxWidth: 150

            },
            {
                id: 'link_id',
                Header: 'Link',
                accessor: 'link_id',
                maxWidth: 150,                
                Cell: e => <a target="_blank" rel="noopener noreferrer" href={`${e.original.link}`}> {e.value} </a>,
                style: { backgroundColor: '#fafafa'}

            },
             {
                id: 'hold_date',
                Header: 'Hold Date',
                maxWidth: 85,
                accessor: d => {
                    if (d.hold_date) {
                        return Moment(d.hold_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }

            },
            {
                id: 'scoped_by',
                Header: 'Hold By',
                accessor: 'scoped_by',
                maxWidth: 85

            }
            , {
                id: 'released_date',
                Header: 'Release Date',
                maxWidth: 85,
                accessor: d => {
                    if (d.released_date) {
                        return Moment(d.released_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                }

            },
            {
                id: 'released_by',
                Header: 'Released By',
                accessor: 'released_by',
                maxWidth: 85

            },{
                Header: '',
                accessor: 'property_withholding_id',
                maxWidth: 100,
                Cell: row => <Button type="button" size="sm" variant="danger" disabled={!this.state.trust_proof || (row.original.link_id !=null  &&  row.original.primary_classification !== "Residential" && row.original.primary_classification !== "Car Park")} onClick={(e) => this.handleReleaseRecord(row,e)}>Remove Hold</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }

    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.withhold_reason}>
                            { (d.withhold_reason ) 
                            }
                        </ListGroup.Item>
                        : ""
            );
        }
    }

    selectAll = event =>{
        let data = [...this.props.data];
        for(var i=0;i<data.length;i++){            
            data[i].selected=true;            
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    deselectAll = event =>{
        let data = [...this.props.data];
        for(var i=0;i<data.length;i++){
            data[i].selected=false;
        }
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderComponent() {
        return (
            <div className="holdings">
                <Modal show={this.state.showAlert && this.props.data[this.props.data.length-1].street_address_id} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showAlert && !this.props.data[this.props.data.length-1].street_address_id &&
                                    <Alert variant="danger">{this.state.errorMessage}</Alert>
                                    }
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >
                        
                    <Nav className="justify-content-start"  >
                             <Nav.Item  >
                            <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                           </Nav.Item> <Nav.Item  >
                             <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                             </Nav.Item>
                    </Nav>
                        
                    </Col>
                    <Col>
                    {!this.state.isLoading &&  this.state.trust_proof && <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleReleaseAllRecord()}>Remove HOLD on Selected </Button>}
                    </Col>
                </Row>} 
                <Row>
                <Col><b>{this.props.data?this.props.data.length: "0"} of {this.props.data? this.props.data.length>0 ? this.props.data[0].result_count: "0":"0"} records returned.</b></Col>
            </Row>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        { !this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) :this.renderPacman() }
                        </Col>
                    </Row>
               

            </div>
        );
    }
    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="WithholdingSection">
                    {this.props.isAuthenticated ? this.renderComponent() : this.renderPacman() }
                </div>
            );
        }
  }
}
